<template>
<address
  class="pb-0 mb-0"
  v-if="item"
>
  <div v-if="displayName">{{ item.name }}</div>

<div v-if="item.address">{{ item.address.postal_code }} {{ item.address.city }}</div>
<div v-if="item.address">{{ item.address.address }}</div>
<div v-if="item.tax_number">
  <small>{{ 'Tax Number'|gettext }}:</small> {{ item.tax_number }}<br/>
</div>
<div v-if="item.account_number">
  <small>{{ 'Account Number'|gettext }}:</small> {{ item.account_number }}
</div>
<div v-if="item.bank">
  <small>{{ 'Bank'|gettext }}:</small> {{ item.bank }}
</div>

</address>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcInvoicePartyPanel extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
  })
  displayName!: boolean;

  @Watch('displayName')
  onDisplay_name(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("displayName")
  }

  ux!: any;
  dataMembers = ['ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        ux: null,
      },
    }
  }

  actions!: {
  }

  getActions() {
    return {
    }
  }
}

Vue.component("UcInvoicePartyPanel", UcInvoicePartyPanel);

</script>